Vendd.Scripts.load(function () {

	Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-version-selector-sku-table', function (envelope) {

		var $context = envelope.message.data.context,
			$controls = $('.x-product-details-version-selector.sku-table', $context);

		if ($controls.length < 1)
			return;

		$.each($controls, function (i, control) {
			var $control = $(control);

			// Properties

			control.loading = function (loading) {
				if (loading === undefined) {
					return $control.hasClass('x-loading');
				}
				else {
					$control.toggleClass('x-loading', loading);
				}
			};

			// Methods

			control.init = function () {
				var $productBoxes = $('.x-product-variant-box', $control);

				$productBoxes.each(function (j, productBox) {
					var $productBox = $(productBox);
					var $quantitySelector = $('.js-quantity-selector', $productBox).first();
					var $unitPriceContainer = $('.js-unit-price', $productBox);
					var $unitPriceValue = $('.js-unit-price-value', $unitPriceContainer);
					var $totalPriceContainer = $('.js-total-price', $productBox);
					var $totalPriceValue = $('.js-total-price-value', $totalPriceContainer);
					var $addToCartButton = $('.js-add-to-cart', $productBox);

					var unitPriceLiteral = $productBox.data('unit-price');
					var unitPriceValue = NumberFormatter.parsePrice(unitPriceLiteral);

					// Properties

					productBox.isEnabled = function () {
						return (unitPriceValue !== undefined);
					};

					productBox.selectedQuantity = function () {
						return productBox.isEnabled() ? $quantitySelector.get(0).quantity() : undefined;
					};

					productBox.unitPrice = function () {
						return unitPriceValue; // NOTE: Might be undefined
					};

					productBox.totalPrice = function () {
						return productBox.unitPrice() * productBox.selectedQuantity(); // NOTE: Might be undefined
					};

					// Methods

					productBox.init = function () {
						$quantitySelector.pdQuantitySelector({
							min: 0, // NOTE: Ignore 'min-quantity'; should always be zero (0).
							max: NumberFormatter.parse($productBox.data('max-quantity')),
							step: NumberFormatter.parse($productBox.data('quanta')),
							value: 0
						});

						productBox.updateQuantitySelector();
						productBox.updateUnitPrice();
						productBox.updateTotalPrice();
						productBox.updateButtonState();
					};

					productBox.addToCart = function () {
						if (control.loading()) {
							return false;
						}

						control.loading(true);

						var data = {
							id: $productBox.data('productid'),
							skuId: $productBox.data('variantid'),
							path: $productBox.data('path'),
							qty: productBox.selectedQuantity(),
							extraAttributes: [],
							bundleItems: [],
							itemInfo: {
								minQuantity: $productBox.data('min-quantity'),
								maxQuantity: $productBox.data('max-quantity'),
								quanta: $productBox.data('quanta')
							}
						};
						Vendd.MessageBus.publishAsync(productBox, new Vendd.Cart.Messages.Add(data.id, data.skuId, data.path, data.qty, data.extraAttributes, data.bundleItems, data.itemInfo));
						//Vendd.MessageBus.publishAsync(productBox, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
						return true;
					};

					productBox.updateQuantitySelector = function () {
						$quantitySelector.pdControlDisabled(productBox.unitPrice() === undefined);
					};

					productBox.updateUnitPrice = function () {
						var value = productBox.unitPrice();
						var valueLiteral = NumberFormatter.formatPrice(value);
						$unitPriceValue.text(valueLiteral);
						$unitPriceContainer.toggleClass('unit-price-visible', 0 < valueLiteral.length);
					};

					productBox.updateTotalPrice = function () {
						var value = productBox.totalPrice();
						var valueLiteral = NumberFormatter.formatPrice(value);
						$totalPriceValue.text(valueLiteral);
						$totalPriceContainer.toggleClass('total-price-visible', 0 < valueLiteral.length);
					};

					productBox.updateButtonState = function () {
						$addToCartButton.pdControlDisabled(productBox.unitPrice() === undefined || productBox.selectedQuantity() === 0 || control.loading());
					};

					// Events

					$quantitySelector.on('product:change', function (e) {
						e.preventDefault();

						productBox.updateTotalPrice();
						productBox.updateButtonState();
					});

					$addToCartButton.on('click', function (e) {
						e.preventDefault();

						if ($addToCartButton.pdControlDisabled()) {
							return;
						}
						if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening')) {
							return;
						}

						productBox.addToCart();
						productBox.updateButtonState();
					});

					Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddCompleted, productBox, function (envelope) {
						control.loading(false);
						productBox.updateButtonState();
					});

					Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, productBox, function (envelope) {
						// NOTE: The 'Vendd.Cart.Messages.AddCompleted' seems to be triggered even 
						// in the case of error, so updating the state of the button doesn't seem
						// to be necessary.
						control.loading(false);
						productBox.updateButtonState();
					});

					// Initialization

					productBox.init();
				});
			};


			// Initialization

			control.init();
		});
	});
});
